// UnsavedModelParametersModal.js
import { Button } from '@blueprintjs/core'
import Modal from '../../templates/popups/Modal'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { EditApplicationParameterHook, StateApplicationParameterHook } from '../hooks/ApplicationParametersHooks'
import { exportModelParameters } from '../../store/slices/modelParametersSlice'
import * as con from '../../GlobalConstants'
import { EditModelValueHook } from '../hooks/ModelParameterHooks'
import { setSurrogateUserById } from '../../store/slices/applicationParametersSlice'

function UnsavedModelParametersModal() {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [showModal, setShowModal] = StateApplicationParameterHook(con.SHOW_UNSAVED_MODAL)
    const [pendingRoute, setPendingRoute] = StateApplicationParameterHook(con.PENDING_ROUTE)
    const [pendingSurrogateUserId, setPendingSurrogateUserId] = StateApplicationParameterHook(con.PENDING_SURROGATE_USER_ID)
    const [pendingLineId, setPendingLineId] = StateApplicationParameterHook(con.PENDING_USER_LINE_ID)
    const setSelectedUserLine = EditApplicationParameterHook(con.SELECTED_LINE)
    const setModelParametersSaved = EditModelValueHook(con.MODEL_PARAMETERS_SAVED);

    const confirmSave = async () => {
        try {
            await dispatch(exportModelParameters()).unwrap()
        } catch (err) {
            console.error(err)
            return
        }
        setShowModal(false)
        setModelParametersSaved(con.NOT_STARTED)  
        if(pendingSurrogateUserId){
            dispatch(setSurrogateUserById(pendingSurrogateUserId))
            setPendingSurrogateUserId(null)  
        } else if (pendingRoute){
            navigate(pendingRoute)
            setPendingRoute(null)
        } else if (pendingLineId){
            setSelectedUserLine(pendingLineId)
            setPendingLineId(null)
        }
    }

    const confirmDiscard = () => {
        setModelParametersSaved(con.NOT_STARTED)
        setShowModal(false)
        if(pendingSurrogateUserId){
            dispatch(setSurrogateUserById(pendingSurrogateUserId))
            setPendingSurrogateUserId(null)  
        } else if (pendingRoute) {
            navigate(pendingRoute)
            setPendingRoute(null)
        } else if (pendingLineId){
            setSelectedUserLine(pendingLineId)
            setPendingLineId(null)
        }
    }

    return (
        <Modal
        show={showModal}
        doAccept={null}
        doCancel={() => setShowModal(false)}
        showCancel={false}
        widthPercentage={40}
        >
        <h3>¿Desea guardar los parámetros antes de cambiar de página?</h3>
        <div className="confirmCancelParameterBox">
            <Button text="Sí" onClick={confirmSave} />
            <Button text="No" onClick={confirmDiscard} />
        </div>
        </Modal>
    )
}

export default UnsavedModelParametersModal